import React, { FC } from 'react';
import classNames from 'classnames';
import styles from './login_input.module.scss';

type Props = {
  placeholder?: string;
  type: string;
  autoComplete?: string;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  spellCheck: boolean;
  required: boolean;
  id: string;
  name?: string;
};

export const LoginInput: FC<Props> = ({
  placeholder = '',
  type,
  autoComplete = '',
  value,
  onChange,
  spellCheck,
  required,
  id,
  name = '',
}) => (
  <input
    className={classNames(styles.input, {
      [styles.password]: type === 'password',
    })}
    value={value}
    onChange={onChange}
    placeholder={placeholder}
    spellCheck={spellCheck}
    required={required}
    id={id}
    data-test-id={id}
    type={type}
    autoComplete={autoComplete}
    name={name}
  />
);
